import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import './NavItems.module.scss';
import signOut from 'actions/authentication/logout';

export default function NavItems(props) {
    const isAuthenticated = useSelector(
        (state) => state.authentication.isLoggedIn
    );
    const dispatch = useDispatch();

    return (
        <>
            <ul>
                {!props.mobile && (
                    <NavLink exact to="/test">
                        <a>Mogelijkheden</a>
                    </NavLink>
                )}
                {props.mobile && (
                    <>
                        <li>
                            <NavLink
                                exact
                                to="/test"
                                activeStyle={{
                                    borderBottom: '4px solid #f4bb56',
                                }}
                            >
                                Mogelijkheden
                            </NavLink>
                        </li>
                    </>
                )}
                <li>
                    <NavLink
                        exact
                        to="/activiteiten"
                        activeStyle={{ borderBottom: '4px solid #f4bb56' }}
                    >
                        Activiteiten
                    </NavLink>
                </li>
                <li>
                    <NavLink
                        exact
                        to="/verhalen"
                        activeStyle={{ borderBottom: '4px solid #f4bb56' }}
                    >
                        Verhalen
                    </NavLink>
                </li>
                <li>
                    <NavLink
                        exact
                        to="/vacatures"
                        activeStyle={{ borderBottom: '4px solid #f4bb56' }}
                    >
                        Vacatures
                    </NavLink>
                </li>
                <li>
                    <NavLink
                        exact
                        to="/over-ons"
                        activeStyle={{ borderBottom: '4px solid #f4bb56' }}
                    >
                        Over ons
                    </NavLink>
                </li>
                <li>
                    <NavLink
                        exact
                        to="/onze-scholen"
                        activeStyle={{ borderBottom: '4px solid #f4bb56' }}
                    >
                        Onze scholen
                    </NavLink>
                </li>
                <li>
                    <NavLink
                        exact
                        to="/contact"
                        activeStyle={{ borderBottom: '4px solid #f4bb56' }}
                    >
                        Contact
                    </NavLink>
                </li>
                {!isAuthenticated ? (
                    <>
                        {props.mobile && (
                            <li>
                                <a
                                    onClick={() =>
                                        props.setLoginModalIsOpen(true)
                                    }
                                >
                                    Inloggen
                                </a>
                            </li>
                        )}
                    </>
                ) : (
                    <>
                        <li>
                            <NavLink
                                exact
                                to="/dashboard"
                                activeStyle={{
                                    borderBottom: '4px solid #f4bb56',
                                }}
                            >
                                Dashboard
                            </NavLink>
                        </li>
                        {props.mobile && (
                            <li>
                                <a onClick={() => dispatch(signOut())}>
                                    Uitloggen
                                </a>
                            </li>
                        )}
                    </>
                )}
            </ul>
        </>
    );
}
